/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { put, select, takeLatest } from 'redux-saga/effects';
import { UPDATE_VALIDATION_CONFIG, updateValidationConfig } from '../actions';
import {
  manageValidationPluginsMode,
  orgValidationUpdates,
  sessionValidationUpdates,
  userValidationUpdates
} from '../data/prefabs';

const handleUpdateValidationConfig = function* ({ payload: {
  forMode,
  namespace,
  setting,
  value
} }) {
  let mode = forMode;
  if (!mode) {
    mode = yield select(manageValidationPluginsMode.value);
  }
  const prefab = mode === 'org' ? orgValidationUpdates : mode === 'userorg' ? userValidationUpdates : sessionValidationUpdates;
  const prefabValue = yield select(prefab.value);
  const updates = setting === 'arguments' && !value ? R.dissocPath([namespace, setting], prefabValue)
    : R.assocPath([namespace, setting], value, prefabValue);
  yield put(prefab.changeAction(updates));

  if (setting === 'level') {
    const updateMode = mode === 'org' ? 'userorg' : mode === 'userorg' ? 'session' : null;
    if (updateMode) {
      yield put(updateValidationConfig({ forMode: updateMode, namespace, setting, value }));
    }
  }
};

export default function* watchUpdateValidationConfig() {
  yield takeLatest(UPDATE_VALIDATION_CONFIG, handleUpdateValidationConfig);
}
